<div #appContent>
    <app-menu role="navigation" class="app-menu" [appPages]="appPages" [activeIndex]="activeMenuItemIndex" [externalRefPages]="externalRefPages">
    </app-menu>

    <div class="layout">
        <header class="header">
            <div class="header-title">
                <span class="title-text">{{ activePageTitleLabelPath | labelsProvider }}</span>
                <img *ngIf="titleIconPath" class="title-icon" [src]="titleIconPath" />
            </div>

            <div class="header-actions">
                <a class="help-container" [href]="baseUrl + '/app/support'" target="_blank">
                    <img
                        matTooltip="Support"
                        matTooltipClass="tooltip-container"
                        matTooltipPosition="below"
                        src="assets/images/common/help.svg"
                        alt="support" />
                </a>
                <app-user></app-user>
            </div>
        </header>
        <main class="content">
            <router-outlet></router-outlet>
        </main>
    </div>
</div>

<app-side-panel #sidePanel [appContent]="appContent" role="complementary"> </app-side-panel>
